import React, { forwardRef } from 'react'
import PoRequest from '../../PoRequest'

const SaleOrder =forwardRef((props,ref) => {
  return (
    <div><PoRequest {...props} creationMode={2} ref={ref}/></div>
  )
})

export default SaleOrder